import { h } from 'preact';
import { FormGroup } from '../FormGroup';
import { Input } from '../Input';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'FormGroup',
  category: '📝 Formulários',
  description: 'Wrapper de formulário com label, required, helper text e erro',
  usedIn: ['AgentesPage', 'Profile', 'Integrations'],
  example: () => (
    <FormGroup label="Email" required helper="Usado para login">
      <Input value="" onChange={() => {}} placeholder="email@exemplo.com" />
    </FormGroup>
  ),
};
